import { ethereum } from '@0xtorch/core'
import { taiko } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createTaikoChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createTaikoChainCustom({
    client: createClient({
      chain: taiko,
      httpRpcs: taikoHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'Taiko Mainnet Explorer',
      baseUrl: 'https://taikoscan.io',
      chainId: 167_000,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateTaikoChainParameters = {
  client: Client
  explorer: Explorer
}

export const createTaikoChainCustom = ({
  client,
  explorer,
}: CreateTaikoChainParameters): Chain => ({
  id: 167_000,
  network: 'taiko',
  name: 'Taiko',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0xa51894664a773981c6c112c43ce576f315d5b1b6',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'taiko',
  defillamaId: 'taiko',
})

export const taikoHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.taiko.xyz',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.ankr.com/taiko',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://taiko.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://taiko-mainnet.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://taiko-json-rpc.stakely.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://node.histori.xyz/taiko-mainnet/8ry9f6t9dct1se2hlagxnd9n2a',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://taiko-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.mainnet.taiko.xyz',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://167000.rpc.thirdweb.com',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
]

export const taikoWebsocketRpcUrls: readonly string[] = [
  'wss://taiko-mainnet.4everland.org/ws/v1/37fa9972c1b1cd5fab542c7bdd4cde2f',
  'wss://taiko.drpc.org',
]
